<template>
  <div class="couponBox">
    <div :style="{width: '100px', height: '100px', backgroundImage: `url(${image.startsWith('http') ? image : image.replace('^/', '')})`,
    backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', borderRadius: '5px',
    backgroundColor: '#CACACA'}"></div>
    <div class="desc">
      <div label="活動名稱: " class="toolong" :style="{
        color: 'var(--color-pri)',
        fontSize: '17px',
        fontWeight: '700'
      }">{{couponName}}</div>
      <div label="贈品名稱: " class="toolong" :style="{
        color: 'var(--color-checked)',
        fontSize: '18px',
        fontWeight: '400',
        marginBottom: '6px'
      }">{{productName}}</div>
      <div class="date">開始日期: {{start}}</div>
      <div class="date">有效期限: {{expire}}</div>
    </div>
    <button @click="$emit('selectThis')"><iconPlus v-if="icon==='select'"/><iconDelete v-else-if="icon==='delete'" color="#E37878" color2="transparent"/></button>
  </div>
</template>

<script>
import iconPlus from '../SVG/iconPlus'
import iconDelete from '../SVG/iconDelete'
export default {
  components: {
    iconPlus,
    iconDelete
  },
  props: {
    icon: {
      type: String,
      default: 'select'
    },
    image: {
      type: String,
      default: '/coffee.png'
    },
    couponName: {
      type: String,
      default: ''
    },
    productName: {
      type: String,
      default: ''
    },
    productID: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    expireTime: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    },
    sendTime: {
      type: String,
      default: ''
    }
  },
  computed: {
    start () {
      return this.toDate(this.startTime || this.sendTime)
    },
    expire () {
      return (this.expireTime
        ? this.toDate(this.expireTime)
        : this.moment(this.sendTime).add(this.duration, 'day').format('YYYY-MM-DD')
      )
    },
    dates () {
      if (this.duration) {
        return `發券日起${this.duration}天`
      } else if (this.startTime && this.expireTime) {
        return `${this.toDate(this.startTime)} ~ ${this.toDate(this.expireTime)}`
      } else {
        return '時間設定錯誤'
      }
    },
    invaild () {
      return (/invaild/ig.test(this.dates) || /錯誤/ig.test(this.dates)) ? 'error' : ''
    }
  }

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.date {
  font-size: 12px;
  font-weight: 400;
  color: #8C8C8C;
  line-height: 18px;
  letter-spacing: .1em;
}
button {
  position: absolute;
  top: 13px;
  right: 13.33px;
  background-color: transparent;
  border: none;
  width: 43px;
  height: 43px;
  padding: 0;
  margin: 0;
}
.desc {
  display: flex;
  flex-direction: column;
  width: 220px;
  // gap: 10px;
}
.desc > div {
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #5E5E5E;
  gap: 12px;
  // &::before {
  //   content: attr(label);
  //   color: #5E5E5E;
  //   font-weight: 400;
  //   font-size: 16px;
  // }
  &.invaild {
    color: var(--highlight);
    font-weight: 900;
    font-size: large;
  }
}
.couponBox {
  position: relative;
  width: 100%;
  height: 120px;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px;
  gap: 14px;
  display: grid;
  grid-template-columns: 110px 1fr;
}
</style>
